import PermissionChecklist from '../../PermissionChecklist';
import EmailChipInput from './EmailChipInput';
import { validateEmail } from './utils';

const addNewUsers = (t: any) => {
  return [
    {
      label: "signup.form.email",
      keyName: "email_list",
      inputProperties: {
        type: 'email',
      },
      Component: EmailChipInput,
      registerOptions: {
        validate: (email: string) => { 
          return validateEmail(email) || t("user_management.errors.invalidEmail");
        }
      }
    },
    {
      label: '',
      keyName: 'permissions',
      Component: PermissionChecklist,
    },
  ];
}

export default addNewUsers;
